import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { PermessiUtente } from "@/types/api";

/**
 * Permessi effettivi dell'utente corrente. Cached 5 minuti.
 *
 * Usa l'helper `hasPermesso(perms, tipo, key)` da `@/lib/permessi` per
 * interpretare il risultato.
 */
export function useMyPermessi() {
  return useQuery({
    queryKey: ["me", "permessi"],
    queryFn: () => apiFetch<PermessiUtente>("/api/v1/me/permessi"),
    staleTime: 5 * 60_000,
  });
}
